import { useEffect, useState } from "react";

export function useClock(intervalMs = 1000) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}

const TPE_FORMAT = new Intl.DateTimeFormat("zh-Hant", {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
  timeZone: "Asia/Taipei",
});

const TPE_DATE = new Intl.DateTimeFormat("zh-Hant", {
  weekday: "short",
  year: "numeric",
  month: "long",
  day: "numeric",
  timeZone: "Asia/Taipei",
});

export function fmtClockTPE(d: Date): { hms: string; date: string } {
  return { hms: TPE_FORMAT.format(d), date: TPE_DATE.format(d) };
}
